import React, { forwardRef } from 'react';
import ReactDOM from 'react-dom';
import ModalInner from './ModalInner/ModalInner';

const Modal = forwardRef((props, ref) => {
    return ReactDOM.createPortal(
        <ModalInner ref={ref} {...props} />,
        document.querySelector('#modal-root')
    );
});

export default Modal;
